module.exports = __webpack_public_path__ + "public/img/logo.464ea013.png";